module.exports = __webpack_public_path__ + "img/wine.36566e92.png";